import { Component, OnInit, Inject, Optional, Input } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LanguageService } from '../../shared/services/language.service';
import {
  MAT_TOOLTIP_DEFAULT_OPTIONS,
  MatTooltipDefaultOptions,
  MatTooltipModule,
} from '@angular/material/tooltip';
import { InfoBarWithStatusService } from '../../shared/services/info-bar-with-status.service';

export const myCustomTooltipDefaults: MatTooltipDefaultOptions = {
  showDelay: 500,
  hideDelay: 500,
  touchendHideDelay: 500,
};

@Component({
  standalone: false,
  selector: 'app-add-tipo-projeto-dialog',
  templateUrl: './add-tipo-projeto-dialog.component.html',
  styleUrls: ['./add-tipo-projeto-dialog.component.css'],
  providers: [{ provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: myCustomTooltipDefaults }],

})
export class AddTipoProjetoDialogComponent implements OnInit {


  variables: any;

  //Temporary static items.
  items: any;

  local_data: any; //local data is the data that has been passed from the parent to this dialog and will be passed back to the parent.
  nameInvalidInput: boolean = false;
  otherInvalidInput: boolean = false;
  riskInvalidInput: boolean = false;

  nameErrorMessage: string = '';
  otherErrorMessage: string = '';
  riskErrorMessage: string = '';

  addForm: any;

  effort = '';

  otherType = false; //Flag to check if the user will add a custom input or use a predefined type. 

  riskInputEffort: any;

  list: any;
  listInCatalog: any;

  isEdit = false;
  itemIndex: number = 0;

  constructor(
    public dialogRef: MatDialogRef<AddTipoProjetoDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private _formBuilder: FormBuilder,
    private infoBar: InfoBarWithStatusService,
    private languageService: LanguageService
  ) {
    this.local_data = { ...data };

    this.list = this.local_data.list;
    this.listInCatalog = this.local_data.listInCatalog;
  }

  ngOnInit(): void {
    this.languageService.translations$.subscribe((vars: any) => {
      this.variables = vars;

    });

    this.isEdit = this.local_data.isEdit
    this.itemIndex = this.local_data.itemIndex;

    // if (this.list && !this.list.some((item: any) => item['name'] === this.variables.other)) this.local_data.list.push({ name: this.variables.other })

    this.addForm = this._formBuilder.group({
      nameCtrl: [{ value: '' }, Validators.required],
      otherCtrl: [{ value: '' }, Validators.required],
      riskCtrl: ['', [Validators.required, Validators.min(1), Validators.max(100)]],
    });

    if (this.local_data.effort) this.effort = this.local_data.effort;


    if (this.isEdit) {

      this.addForm.get('riskCtrl')?.setValue(this.local_data.item.risk);

      if (this.local_data.item.name === this.variables.tm || this.local_data.item.name === this.variables.fixedPrice) {
        this.addForm.get('nameCtrl')?.setValue(this.local_data.item.name);
      }
      else {
        this.otherType = true
        this.addForm.get('otherCtrl')?.setValue(this.local_data.item.name);
        this.addForm.get('nameCtrl')?.setValue(this.variables.other);
      }
    }
    else {
      this.addForm.get("nameCtrl").valueChanges.subscribe((result: any) => {
        if (result === this.variables.other) {
          this.otherType = true;
          this.addForm.get('otherCtrl')?.setValue('');
          this.addForm.get('riskCtrl').setValue('');
        }
        else this.otherType = false;
        if (result == this.variables.fixedPrice) {
          this.addForm.get('riskCtrl').setValue(10);
        }
        if (result === this.variables.tm) {
          this.addForm.get('riskCtrl').setValue(8);
        }

        if (result.nameCtrl) this.nameInvalidInput = false;
      })
    }
  }


  doAction() {
    var valid = true;

    if (!this.addForm.valid) {
      const formGroup = this.addForm.value;

      if (!formGroup.nameCtrl) {
        this.nameInvalidInput = true;
        this.nameErrorMessage = this.variables.chooseProjectType;
        valid = false;
      } else {
        this.nameInvalidInput = false;
      }

      if (this.otherType && !formGroup.otherCtrl) {
        this.otherInvalidInput = true;
        this.otherErrorMessage = this.variables.insertNameMessage;
        valid = false;
      } else {
        this.otherInvalidInput = false;
      }

      if (
        formGroup.riskCtrl === null ||
        formGroup.riskCtrl === undefined ||
        formGroup.riskCtrl === '' ||
        formGroup.riskCtrl <= 0 ||
        formGroup.riskCtrl > 100
      ) {
        this.riskInvalidInput = true;
        this.riskErrorMessage = this.variables.numberBetweenZeroUndred;
        valid = false;
        return;
      } else {
        this.riskInvalidInput = false;
      }


      return;
    }

    const formGroup = this.addForm.value;

    this.listInCatalog.some((item: any, index: number) => {

      if (index != this.itemIndex) {
        if (item.name === formGroup.otherCtrl) {
          this.otherInvalidInput = true;
          this.otherErrorMessage = this.variables.alreadyExists;
          valid = false;
        } else if (item.name === formGroup.nameCtrl) {
          this.nameInvalidInput = true;
          this.nameErrorMessage = this.variables.alreadyExists;
          valid = false;
        }
        return;
      }
    });



    this.local_data.name = this.otherType ? formGroup.otherCtrl : formGroup.nameCtrl;
    this.local_data.risk = formGroup.riskCtrl;

    if (valid) {
      this.dialogRef.close({ data: this.local_data });
    }
    else {
      this.infoBar.showSnackbar(this.variables.errorInForm, ['error-snackbar'], 2000);
    }
  }

}
